import { FC, memo } from 'react';
import { FloatButton as AntdFloatButton } from 'antd';
import type { FloatButtonProps as AntdFloatButtonProps } from 'antd';

export type FloatButtonPropsType = AntdFloatButtonProps & {
    authCode?: string;
};

const FloatButton: FC<FloatButtonPropsType> = memo((props) => {
    const {
        children,
        ...rest
    } = props;

    return (
        <>
            <AntdFloatButton {...rest}>
                {children}
            </AntdFloatButton>
        </>
    );
});

export default FloatButton;
